import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import data from '../sample/data';
import { useEffect, useState } from 'react';

function HomePage() {
  const { t } = useTranslation();
  const { profile } = data;

  const words = [profile.role];
  const [display, setDisplay] = useState('');
  useEffect(() => {
    let i = 0, j = 0, dir = 1;
    const interval = setInterval(() => {
      const target = words[i];
      j += dir;
      if (j === target.length + 1) { dir = -1; }
      if (j === 0) { dir = 1; i = (i + 1) % words.length; }
      setDisplay(target.slice(0, Math.max(0, j)));
    }, 80);
    return () => clearInterval(interval);}, []);
  return (
    <div className="relative">
      <div className="absolute inset-0 -z-10 opacity-30 blur-3xl" aria-hidden>
        <div className="from-primary/30 to-accent/30 bg-gradient-to-br w-[40rem] h-[40rem] rounded-full absolute -top-40 -left-20" />
        <div className="from-accent/20 to-primary/20 bg-gradient-to-tr w-[30rem] h-[30rem] rounded-full absolute top-40 right-0" />
      </div>

      <section className="min-h-[80vh] grid items-center">
        <div className="grid md:grid-cols-[auto,1fr] items-center gap-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.1 }}
            className="justify-self-center md:justify-self-start"
          >
            <img
              src={profile.avatar}
              alt={profile.name}
              className="w-32 h-32 md:w-40 md:h-40 rounded-full ring-2 ring-accent/50 shadow-glass object-cover"
            />
          </motion.div>

          <div className="space-y-6">
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-sm uppercase tracking-widest text-slate-600 dark:text-foreground/60"
            >
              Hello, I'm
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-4xl md:text-6xl font-bold tracking-tight"
            >
              {profile.name}
            </motion.h1>
            <p className="text-accent text-lg md:text-2xl h-8">{display}<span className="animate-pulse">|</span></p>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-lg md:text-xl text-slate-700 dark:text-foreground/80 max-w-2xl"
            >
              {t('home_tagline')}
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="flex flex-wrap items-center gap-3"
            >
              <Link
                to="/projects"
                className="px-5 py-2.5 rounded-lg bg-primary text-primary-foreground shadow-glass hover:opacity-90"
              >
                {t('cta_projects')}
              </Link>
              <a
                href="/resume.pdf"
                className="px-5 py-2.5 rounded-lg border border-slate-300 dark:border-white/10 hover:border-slate-400 dark:hover:border-white/20"
                download
              >
                {t('cta_resume')}
              </a>
              <div className="ml-1 flex items-center gap-2">
                <a href="https://github.com/amit512" target="_blank" rel="noreferrer" aria-label="GitHub" className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:bg-white/5">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M12 2C6.477 2 2 6.486 2 12.021c0 4.428 2.865 8.184 6.839 9.504.5.092.682-.218.682-.484 0-.237-.009-.866-.013-1.7-2.782.607-3.369-1.343-3.369-1.343-.454-1.156-1.11-1.465-1.11-1.465-.908-.62.069-.607.069-.607 1.004.071 1.532 1.037 1.532 1.037.892 1.537 2.341 1.093 2.91.836.091-.647.35-1.094.636-1.345-2.221-.254-4.555-1.115-4.555-4.96 0-1.095.39-1.992 1.029-2.694-.103-.254-.446-1.278.098-2.664 0 0 .84-.27 2.75 1.028A9.564 9.564 0 0 1 12 6.844a9.56 9.56 0 0 1 2.505.337c1.909-1.298 2.748-1.028 2.748-1.028.546 1.386.203 2.41.1 2.664.64.702 1.028 1.599 1.028 2.694 0 3.855-2.337 4.704-4.565 4.953.359.31.679.921.679 1.857 0 1.34-.012 2.42-.012 2.75 0 .268.18.58.688.481C19.138 20.2 22 16.446 22 12.02 22 6.486 17.523 2 12 2Z"/></svg>
                </a>
                <a href="https://www.linkedin.com/in/amit-raut-8b443b263?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-10 w-10 grid place-items-center rounded-full border border-white/10 hover:bg-white/5">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M6.94 6.5A2.44 2.44 0 1 1 6.94 1.62a2.44 2.44 0 0 1 0 4.88ZM2.88 8.37h8.15v12.5H2.88V8.37Zm9.88 0h7.47v2.03h.1c1.04-1.77 3.56-2.03 5.13-2.03 5.5 0 6.51 3.62 6.51 8.33v9.1h-8.15v-8.06c0-1.92-.03-4.39-2.67-4.39-2.68 0-3.09 2.09-3.09 4.25v8.2h-8.15V8.37Z"/></svg>
                </a>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="mt-12 flex items-center gap-2 text-sm text-foreground/70">
          <span className="h-px w-10 bg-foreground/20" aria-hidden />
          <span>Scroll to explore</span>
          <span className="h-px w-10 bg-foreground/20" aria-hidden />
        </div>
      </section>

      <section id="highlights" className="py-14">
        <h2 className="text-xl font-semibold mb-6">Highlights</h2>
        <ul className="grid md:grid-cols-2 gap-3">
          {data.highlights.map((h) => (
            <li key={h} className="px-4 py-3 rounded-lg border border-white/10 bg-white/5">{h}</li>
          ))}
        </ul>
      </section>

      <section id="featured-projects" className="py-14">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold">Featured Projects</h2>
          <Link to="/projects" className="text-sm text-accent hover:underline">View all</Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {data.projects.slice(0, 3).map((p) => (
            <article key={p.id} className="rounded-xl overflow-hidden border border-white/10 bg-white/5">
              <img src={p.image} alt="" className="h-36 w-full object-cover" />
              <div className="p-4 space-y-2">
                <h3 className="font-semibold">{p.title}</h3>
                <p className="text-sm text-foreground/80 line-clamp-2">{p.description}</p>
                <div className="flex flex-wrap gap-2 text-xs text-foreground/70">
                  {p.stack.map(s => (
                    <span key={s} className="px-2 py-0.5 rounded-full bg-white/10 border border-white/10">{s}</span>
                  ))}
                </div>
                <div className="pt-2 flex gap-3 text-sm">
                  {p.demo !== '#' && <a href={p.demo} target="_blank" rel="noreferrer" className="text-accent hover:underline">Live</a>}
                  {p.github !== '#' && <a href={p.github} target="_blank" rel="noreferrer" className="text-accent hover:underline">Code</a>}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="recent-posts" className="py-14">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold">Recent Posts</h2>
          <Link to="/blog" className="text-sm text-accent hover:underline">View all</Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {data.blogs
            .slice()
            .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0))
            .slice(0, 3)
            .map((post, idx) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: idx * 0.05 }}
                className="rounded-xl overflow-hidden border border-white/10 bg-white/5 hover:border-accent/40 transition-colors"
              >
                <img src={post.image} alt="" className="h-36 w-full object-cover" />
                <div className="p-4 space-y-2">
                  <div className="text-xs text-foreground/70">{post.date ? new Date(post.date).toLocaleDateString() : ''}</div>
                  <h3 className="font-semibold line-clamp-2">{post.title}</h3>
                  <p className="text-sm text-foreground/80 line-clamp-2">{post.excerpt}</p>
                </div>
              </motion.article>
            ))}
        </div>
      </section>
    </div>
  );
}

export default HomePage;


